/* eslint-disable */
export default {
  unknown: 'Tuntematon',
  multipleMatches: 'Useita osumia',
  anonymous: 'Nimetön',
  none: 'Ei mitään',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
